import { useEffect, useState } from 'react';

export function usePageTitle(recordName: string | null | undefined) {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('page-title-override', { detail: recordName || null }));
    return () => {
      window.dispatchEvent(new CustomEvent('page-title-override', { detail: null }));
    };
  }, [recordName]);
}

export function usePageTitleOverride(): string | null {
  const [override, setOverride] = useState<string | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setOverride(detail || null);
    };
    window.addEventListener('page-title-override', handler);
    return () => window.removeEventListener('page-title-override', handler);
  }, []);

  return override;
}
